module.exports = __webpack_public_path__ + "img/works_nikkei_telecon_3.0e2eafd6.png";